<h2 mat-dialog-title>{{ data.title }}</h2>

<div mat-dialog-content>
  <p class="desc">{{ data.description }}</p>

  <mat-form-field appearance="outline" class="reason-field" *ngIf="asksReason">
    <mat-label>{{ data.reason?.label }}</mat-label>
    <textarea
      matInput
      [(ngModel)]="reason"
      name="reason"
      rows="3"
      maxlength="500"
    ></textarea>
    <mat-hint *ngIf="data.reason?.hint">{{ data.reason?.hint }}</mat-hint>
  </mat-form-field>

  <ng-container *ngIf="sendsEmail">
    <div class="divider"></div>

    <div class="no-address" *ngIf="!hasAddress">
      No email address on file for this account — nothing will be sent.
      The action below still happens.
    </div>

    <ng-container *ngIf="hasAddress">
      <div class="email-head">
        <span class="email-label">This sends an email to {{ data.emailPreview?.to }}</span>
        <button
          type="button"
          class="reset-link"
          (click)="resetEmail()"
          [disabled]="!edited"
        >
          Reset to default
        </button>
      </div>

      <mat-form-field appearance="outline" class="subject-field">
        <mat-label>Subject</mat-label>
        <input matInput [(ngModel)]="subject" name="subject" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="body-field">
        <mat-label>Message</mat-label>
        <textarea matInput [(ngModel)]="text" name="text" rows="10"></textarea>
      </mat-form-field>

      <p class="edited-note" *ngIf="edited">
        Edited from the default — this is what will actually send.
      </p>
    </ng-container>
  </ng-container>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button
    mat-flat-button
    [color]="data.danger ? 'warn' : 'primary'"
    (click)="confirm()"
  >
    {{ data.confirmLabel }}
  </button>
</div>
